<template>
    <el-container class="layout-container">
        <!-- 移动端遮罩 -->
        <div
                v-if="mobileMenuOpen"
                class="mobile-overlay"
                @click="closeMobileMenu"
        ></div>

        <!-- 左侧边栏 -->
        <el-aside
                :width="isMobile ? '220px' : (isCollapse ? '64px' : '220px')"
                :class="['layout-aside', { 'aside-mobile': isMobile, 'aside-mobile-open': mobileMenuOpen }]"
        >
            <!-- Logo 区域 -->
            <div class="aside-header" @click="toggleCollapse">
                <img src="@/assets/logo.png" class="aside-logo" alt="logo" />
            </div>
            <el-menu
                    ref="sideMenu"
                    :default-active="activeMenu"
                    :default-openeds="defaultOpeneds"
                    :collapse="isMobile ? false : isCollapse"
                    :collapse-transition="false"
                    background-color="#004070"
                    text-color="#b8d4e8"
                    active-text-color="#4db8e8"
                    class="side-menu"
                    @select="onMenuSelect"
            >
                <el-submenu index="employee-group" v-if="canView('personnel') || canView('user') || canView('role') || canView('department') || canView('attendance') || canView('duty-mgmt') || isAdminTier()">
                    <template slot="title">
                        <i class="el-icon-s-home"></i>
                        <span>员工管理</span>
                    </template>
                    <el-menu-item index="/personnel" v-if="canView('personnel')">
                        <span slot="title">人事档案</span>
                    </el-menu-item>
                    <el-menu-item index="/user" v-if="canView('user')">
                        <span slot="title">用户管理</span>
                    </el-menu-item>
                    <el-menu-item index="/role" v-if="canView('role')">
                        <span slot="title">角色管理</span>
                    </el-menu-item>
                    <el-menu-item index="/department" v-if="canView('department')">
                        <span slot="title">部门管理</span>
                    </el-menu-item>
                    <el-menu-item index="/attendance" v-if="canView('attendance')">
                        <span slot="title">考勤管理</span>
                    </el-menu-item>
                    <el-menu-item index="/duty-mgmt" v-if="canView('duty-mgmt')">
                        <span slot="title">值班管理</span>
                    </el-menu-item>
                    <el-menu-item index="/role-page-permission" v-if="isAdminTier()">
                        <span slot="title">角色页面权限</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="project-group" v-if="canView('pm') || canView('drawing-library') || canView('quote') || canView('quote-material')">
                    <template slot="title">
                        <i class="el-icon-s-management"></i>
                        <span>项目管理</span>
                    </template>
                    <el-menu-item index="/pm" v-if="canView('pm')">
                        <span slot="title">项目管理</span>
                    </el-menu-item>
                    <el-menu-item index="/company-project-stats" v-if="canView('pm')">
                        <span slot="title">公司项目统计</span>
                    </el-menu-item>
                    <el-menu-item index="/quote-mgmt" v-if="canView('quote')">
                        <span slot="title">工程报价</span>
                    </el-menu-item>
                    <el-menu-item index="/quote-material" v-if="canView('quote-material')">
                        <span slot="title">报价物料明细</span>
                    </el-menu-item>
                    <el-menu-item index="/drawing-library" v-if="canView('drawing-library')">
                        <span slot="title">工程图纸库</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="supply-group" v-if="canView('supplier-mgmt') || canView('purchasematerialtype') || canView('purchasemateriallist')">
                    <template slot="title">
                        <i class="el-icon-s-shop"></i>
                        <span>供应链管理</span>
                    </template>
                    <el-menu-item index="/supplier-mgmt" v-if="canView('supplier-mgmt')">
                        <span slot="title">供应商管理</span>
                    </el-menu-item>
                    <el-menu-item index="/supplier-ledger" v-if="canView('supplier-mgmt')">
                        <span slot="title">供应商往来台账</span>
                    </el-menu-item>
                    <el-menu-item index="/purchasematerialtype" v-if="canView('purchasematerialtype')">
                        <span slot="title">物料类别</span>
                    </el-menu-item>
                    <el-menu-item index="/purchasemateriallist" v-if="canView('purchasemateriallist')">
                        <span slot="title">物料列表</span>
                    </el-menu-item>
                    <el-menu-item index="/supplier-evaluation" v-if="canView('supplier-evaluation')">
                        <span slot="title">供应商考评</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="bidding-group" v-if="canView('bidding-project') || canView('bidding-registration') || canView('bidding-notice') || canView('bidding-evaluation') || canView('bidding-award') || canView('bidding-document') || canView('bidding-qa') || canView('bidding-section') || canView('bidding-archive') || canView('cost-analysis')">
                    <template slot="title">
                        <i class="el-icon-s-order"></i>
                        <span>招投标管理</span>
                    </template>
                    <el-menu-item index="/bidding-project" v-if="canView('bidding-project')">
                        <span slot="title">招标立项</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-registration" v-if="canView('bidding-registration')">
                        <span slot="title">投标报名</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-notice" v-if="canView('bidding-notice')">
                        <span slot="title">招标公告管理</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-evaluation" v-if="canView('bidding-evaluation')">
                        <span slot="title">开标评标</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-award" v-if="canView('bidding-award')">
                        <span slot="title">定标管理</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-document" v-if="canView('bidding-document')">
                        <span slot="title">招标文件管理</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-qa" v-if="canView('bidding-qa')">
                        <span slot="title">线上答疑</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-section" v-if="canView('bidding-section')">
                        <span slot="title">标段管理</span>
                    </el-menu-item>
                    <el-menu-item index="/bidding-archive" v-if="canView('bidding-archive')">
                        <span slot="title">招标档案中心</span>
                    </el-menu-item>
                    <el-menu-item index="/cost-analysis" v-if="canView('cost-analysis')">
                        <span slot="title">成本分析看板</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="contract-group" v-if="canView('contract-mgmt') || canView('contract-progress') || canView('payment-mgmt') || canView('acceptance-mgmt') || canView('financial')">
                    <template slot="title">
                        <i class="el-icon-s-cooperation"></i>
                        <span>合同与财务</span>
                    </template>
                    <el-menu-item index="/contract-mgmt" v-if="canView('contract-mgmt')">
                        <span slot="title">合同管理</span>
                    </el-menu-item>
                    <el-menu-item index="/contract-progress" v-if="canView('contract-progress')">
                        <span slot="title">履约进度</span>
                    </el-menu-item>
                    <el-menu-item index="/payment-mgmt" v-if="canView('payment-mgmt')">
                        <span slot="title">对账付款</span>
                    </el-menu-item>
                    <el-menu-item index="/acceptance-mgmt" v-if="canView('acceptance-mgmt')">
                        <span slot="title">验收管理</span>
                    </el-menu-item>
                    <el-menu-item index="/financial" v-if="canView('financial')">
                        <span slot="title">财务管理</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="support-group" v-if="canView('notification-center') || canView('approval-center') || canView('approval-design') || canView('approval-archive') || canView('approval-efficiency') || canView('schedule') || canView('workbench') || canView('document-center') || canView('system-log') || canView('dashboard') || canView('security-risk')">
                    <template slot="title">
                        <i class="el-icon-s-tools"></i>
                        <span>系统工具</span>
                    </template>
                    <el-menu-item index="/workbench" v-if="canView('workbench')">
                        <span slot="title">统一工作台</span>
                    </el-menu-item>
                    <el-menu-item index="/approval-center" v-if="canView('approval-center')">
                        <span slot="title">审批流程</span>
                    </el-menu-item>
                    <el-menu-item index="/approval-design" v-if="canView('approval-design')">
                        <span slot="title">流程设计</span>
                    </el-menu-item>
                    <el-menu-item index="/approval-archive" v-if="canView('approval-archive')">
                        <span slot="title">流程归档</span>
                    </el-menu-item>
                    <el-menu-item index="/approval-efficiency" v-if="canView('approval-efficiency')">
                        <span slot="title">效率分析</span>
                    </el-menu-item>
                    <el-menu-item index="/schedule" v-if="canView('schedule')">
                        <span slot="title">日程</span>
                    </el-menu-item>
                    <el-menu-item index="/notification-center" v-if="canView('notification-center')">
                        <span slot="title">消息通知</span>
                    </el-menu-item>
                    <el-menu-item index="/document-center" v-if="canView('document-center')">
                        <span slot="title">文档中心</span>
                    </el-menu-item>
                    <el-menu-item index="/system-log" v-if="canView('system-log')">
                        <span slot="title">操作审计</span>
                    </el-menu-item>
                    <el-menu-item index="/dashboard" v-if="canView('dashboard')">
                        <span slot="title">数据大屏</span>
                    </el-menu-item>
                    <el-menu-item index="/security-risk" v-if="canView('security-risk')">
                        <span slot="title">安全风控</span>
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </el-aside>

        <!-- 右侧主体 -->
        <el-container class="main-container">
            <!-- 顶部栏 -->
            <el-header class="layout-header">
                <div class="header-left">
                    <!-- 移动端汉堡菜单 -->
                    <i v-if="isMobile" class="el-icon-s-operation header-menu-btn" @click="toggleMobileMenu"></i>
                    <i v-else class="el-icon-s-fold header-collapse-icon" @click="toggleCollapse"></i>
                    <span class="header-company-name">西安华府人家装饰工程有限公司</span>
                </div>
                <div class="header-right">
                    <span class="username" :title="userName">{{ isMobile ? '' : userName }}</span>
                    <el-button type="text" class="logout-btn" @click="handleLogout">
                        {{ isMobile ? '退出' : '退出' }}
                    </el-button>
                </div>
            </el-header>

            <!-- 内容区 -->
            <el-main class="layout-main">
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import Vue from 'vue'
    import * as pagePerm from '@/utils/pagePerm'

    export default {
        name: 'Layout',
        data() {
            return {
                isCollapse: false,
                mobileMenuOpen: false,
                userName: '',
                isMobile: false,
                userPermissions: [],
                viewPermission: 1
            }
        },
        computed: {
            activeMenu() {
                const path = this.$route.path
                // 项目详情页没有独立菜单项，高亮保持「项目管理」
                if (path.startsWith('/project-detail/')) return '/pm'
                return path
            },
                defaultOpeneds() {
                const path = this.$route.path
                const groups = {
                    '/pm': 'project-group', '/company-project-stats': 'project-group', '/drawing-library': 'project-group', '/quote-mgmt': 'project-group', '/personnel': 'employee-group', '/financial': 'contract-group',
                    '/user': 'employee-group', '/role': 'employee-group', '/department': 'employee-group',
                    '/attendance': 'employee-group',
                    '/duty-mgmt': 'employee-group',
                    '/supplier-mgmt': 'supply-group', '/supplier-ledger': 'supply-group', '/purchasematerialtype': 'supply-group',
                    '/purchasemateriallist': 'supply-group',
                    '/bidding-project': 'bidding-group',
                    '/bidding-registration': 'bidding-group',
                    '/bidding-notice': 'bidding-group', '/bidding-evaluation': 'bidding-group',
                    '/bidding-award': 'bidding-group', '/bidding-document': 'bidding-group',
                    '/bidding-qa': 'bidding-group', '/bidding-section': 'bidding-group',
                    '/bidding-archive': 'bidding-group', '/cost-analysis': 'bidding-group',
                    '/contract-mgmt': 'contract-group', '/contract-progress': 'contract-group',
                    '/payment-mgmt': 'contract-group', '/acceptance-mgmt': 'contract-group',
                    '/notification-center': 'support-group', '/approval-center': 'support-group',
                    '/approval-design': 'support-group', '/approval-archive': 'support-group',
                    '/approval-efficiency': 'support-group',
                    '/schedule': 'support-group', '/workbench': 'support-group',
                    '/document-center': 'support-group',
                    '/system-log': 'support-group', '/dashboard': 'support-group',
                    '/security-risk': 'support-group',
                    '/supplier-evaluation': 'supply-group'
                }
                // 项目详情页归入项目管理分组
                if (path.startsWith('/project-detail/')) return ['project-group']
                const g = groups[path]
                return g ? [g] : ['employee-group']
            }
        },
        watch: {
            '$route.path': {
                immediate: true,
                handler() {
                    this.$nextTick(() => this.syncMenuOpen())
                }
            }
        },
        methods: {
            syncMenuOpen() {
                const menu = this.$refs.sideMenu
                if (!menu) return
                const allGroups = ['employee-group', 'project-group', 'supply-group', 'bidding-group', 'contract-group', 'support-group']
                allGroups.forEach(g => {
                    if (this.defaultOpeneds.includes(g)) menu.open(g)
                    else menu.close(g)
                })
            },
            hasPermission() {
                // 已废弃：菜单门禁改为按页面 key 的 canView/canAdd/canEdit/canDelete
                return false
            },
            canView(pageKey) { return pagePerm.canView(pageKey) },
            canAdd(pageKey) { return pagePerm.canAdd(pageKey) },
            canEdit(pageKey) { return pagePerm.canEdit(pageKey) },
            canDelete(pageKey) { return pagePerm.canDelete(pageKey) },
            isAdminTier() { return pagePerm.isAdminTier() },
            checkMobile() {
                this.isMobile = window.innerWidth < 768
                if (this.isMobile) {
                    this.isCollapse = true
                }
            },
            toggleCollapse() {
                if (this.isMobile) {
                    this.toggleMobileMenu()
                } else {
                    this.isCollapse = !this.isCollapse
                }
            },
            toggleMobileMenu() {
                this.mobileMenuOpen = !this.mobileMenuOpen
            },
            closeMobileMenu() {
                this.mobileMenuOpen = false
            },
            onMenuSelect(index) {
                if (index) {
                    this.$router.push(index).catch(err => {
                        if (err.name !== 'NavigationDuplicated') throw err
                    })
                }
                if (this.isMobile) {
                    this.mobileMenuOpen = false
                }
            },
            fetchUserInfo() {
                this.$http.get('/userInfo').then((res) => {
                    if (res.data) {
                        this.userName = res.data.name || res.data.username || ''
                        this.viewPermission = res.data.viewPermission || 1
                        this.userPermissions = res.data.permissions || []
                        localStorage.setItem('userInfo', JSON.stringify(res.data))
                        localStorage.setItem('userPermissions', JSON.stringify(this.userPermissions))
                        localStorage.setItem('viewPermission', String(this.viewPermission))
                        localStorage.setItem('pagePermissions', JSON.stringify(res.data.pagePermissions || {}))
                        // 菜单门禁 canView() 直接读 localStorage（非响应式），权限回填后强制重绘一次，
                        // 否则首次加载/换账号时左侧菜单会一直空白。
                        this.$nextTick(() => this.$forceUpdate())
                        // 特权接口 /user/userList 要求 viewPermission>=3；低权限调用必 403，
                        // 而 axios 拦截器会把 403 统一弹成「权限不足，需要管理员层级」红条
                        //（下面 fetchUserInfo 的 catch 拦不住——拦截器已先弹过）
                        // ⇒ 只有管理员层级才请求它。低权限时 _userNameMap 保持 null，
                        //   $displayName 退回显示原值（与修复前 403 的表现完全一致）。
                        if (this.viewPermission >= 3) {
                            this.$http.post('/user/userList', { page: 1, perPage: 999 }).then(r => {
                                const list = r.data.list || []
                                const map = {}
                                list.forEach(u => {
                                    if (u.username) map[u.username] = u.name
                                    if (u.id != null) map[String(u.id)] = u.name
                                })
                                Vue.prototype._userNameMap = map
                            }).catch(() => {})
                        }
                    }
                }).catch(() => {
                    this.userName = ''
                })
            },
            handleLogout() {
                localStorage.removeItem('token')
                this.$router.push('/Login')
            }
        },
        created() {
            this.checkMobile()
            window.addEventListener('resize', this.checkMobile)
            this.fetchUserInfo()
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile)
        }
    }
</script>

<style scoped>
    .layout-container {
        height: 100vh;
    }

    /* ===== 移动端遮罩 ===== */
    .mobile-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 998;
    }

    /* ===== 侧边栏 ===== */
    .layout-aside {
        background-color: #004070;
        transition: width 0.2s ease;
        overflow: hidden;
        z-index: 999;
        will-change: width;
    }

    /* 菜单文字过渡 */
    .side-menu >>> .el-menu-item span,
    .side-menu >>> .el-submenu__title span {
        transition: opacity 0.15s ease;
    }
    .side-menu >>> .el-menu--collapse .el-menu-item span,
    .side-menu >>> .el-menu--collapse .el-submenu__title span {
        opacity: 0;
    }

    /* Logo 头部区域 */
    .aside-header {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background-color: #002a4a;
        cursor: pointer;
        user-select: none;
        padding: 0 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }

    .aside-logo {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        object-fit: contain;
    }

    .aside-title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        white-space: nowrap;
        letter-spacing: 1px;
    }

    .collapse-icon-alone {
        font-size: 20px;
        color: #b8d4e8;
    }

    /* 侧边菜单 */
    .side-menu {
        border-right: none;
    }

    .side-menu >>> .el-menu-item:hover,
    .side-menu >>> .el-submenu__title:hover {
        background-color: #005a90 !important;
    }

    .side-menu >>> .el-menu--inline {
        background-color: #003560 !important;
    }

    .side-menu >>> .el-menu--inline .el-menu-item {
        background-color: #003560 !important;
    }

    .side-menu >>> .el-menu--inline .el-menu-item:hover {
        background-color: #005a90 !important;
    }

    /* ===== 顶部栏 ===== */
    .main-container {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        height: 100vh;
        overflow: hidden;
    }

    .layout-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        border-bottom: 1px solid #d8e4ec;
        padding: 0 16px;
        height: 56px;
        box-shadow: 0 1px 4px rgba(0, 64, 112, 0.06);
    }

    .header-left {
        display: flex;
        align-items: center;
        gap: 10px;
        overflow: hidden;
    }

    .header-menu-btn {
        font-size: 22px;
        color: #004070;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        flex-shrink: 0;
    }

    .header-collapse-icon {
        font-size: 20px;
        color: #004070;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: background 0.2s;
        flex-shrink: 0;
    }

    .header-collapse-icon:hover {
        background-color: #e0f0f0;
    }

    .header-company-name {
        font-size: 15px;
        font-weight: 600;
        color: #004070;
        letter-spacing: 1px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .header-right {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    .username {
        color: #606266;
        font-size: 13px;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .logout-btn {
        color: #909399;
        font-size: 13px;
        padding: 4px 8px;
    }

    .logout-btn:hover {
        color: #004070;
    }

    /* ===== 内容区域 ===== */
    .layout-main {
        background: #edf4f7;
        padding: 12px;
        overflow: hidden;
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    /* ===== 移动端适配 ===== */
    @media (max-width: 767px) {
        .layout-aside {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            transform: translateX(-100%);
        }

        .aside-mobile-open {
            transform: translateX(0);
        }

        .layout-header {
            height: 50px;
            padding: 0 12px;
        }

        .header-company-name {
            font-size: 12px;
            letter-spacing: 0;
        }

        .layout-main {
            padding: 8px;
        }
    }

    /* ===== 平板适配 ===== */
    @media (min-width: 768px) and (max-width: 1024px) {
        .layout-header {
            height: 56px;
            padding: 0 16px;
        }

        .layout-main {
            padding: 14px;
        }
    }
</style>
